<template>
  <div>
    <iframe v-if="initialized"
            class="hidden-iframe"
            :src="logoutUrl"></iframe>
  </div>

</template>

<script>
import sisenseService from '@/common/utils/sisense-service'
import { EventBus, events } from '@/common/EventBus'

export default {
  name: 'SisenseLogout',
  data: () => ({
    initialized: false,
    overrideUrl: null,
    sisenseHost: null
  }),
  computed: {
    logoutUrl () {
      if (this.overrideUrl !== null) {
        return this.overrideUrl
      }
      if (!this.sisenseHost) {
        return null
      }
      return this.sisenseHost + '/api/v1/authentication/logout'
    }
  },
  created () {
    return sisenseService.settings()
      .then(settings => {
        this.sisenseHost = settings.host
      })
  },
  mounted () {
    EventBus.$on(events.sessionTimedOut, () => this.logout())
  },
  beforeDestroy () {
    EventBus.$off(events.sessionTimedOut)
  },
  methods: {
    reload () {
      /*
       * Change the URL to force the iframe to reload.
       * Wait 1 tick for the change to take effect.
       *
       * BTW, the iframe is used to get around CORS,
       * and it uses the same session cookie as the other Sisense iframes.
       */
      this.overrideUrl = ''
      this.$nextTick(() => this.overrideUrl = null)
    },
    logout () {
      if (this.initialized) {
        this.reload()
      } else {
        this.initialized = true
      }
    }
  }
}
</script>

<style>
  .hidden-iframe {
    height: 0;
    width: 0;
    border: 0;
    display: block;
  }
</style>
